import React from 'react'
import KeyCards from './Card/KeyCards'

function Home() {
  return (
    
      <KeyCards/>
   
  )
}

export default Home
